import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "appIcon"];
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect, useState } from 'react';
import { EmbersVerticalNav } from './verticalNav';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Backdrop from '@mui/material/Backdrop';
import { ROOT_PREFIX, StyledMobileNavBarContainer } from './mobileNavBarStyles';
import classnames from 'classnames';
export var EmbersMobileNavBar = function EmbersMobileNavBar(_ref) {
  var className = _ref.className,
    appIcon = _ref.appIcon,
    navProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedNav = _useState2[0],
    setSelectedNav = _useState2[1];
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    expanded = _React$useState2[0],
    setExpanded = _React$useState2[1];
  var handleChange = function handleChange() {
    return function (event, isExpanded) {
      setExpanded(isExpanded);
    };
  };
  var getSelectedNavInfo = function getSelectedNavInfo() {
    var items = _toConsumableArray(navProps.navItems);
    while (items.length) {
      var item = items.shift();
      if (item) {
        if (item.nodeId === navProps.defaultSelected) return item;
        if (item.childNodes) items.push.apply(items, _toConsumableArray(item.childNodes));
      }
    }
  };
  useEffect(function () {
    // the first primary navigation item will be selected and expanded by default
    // if not otherwise specified by the selected and expanded props
    var selectedItem = null;
    if (navProps.defaultSelected) {
      if (navProps.defaultSelected !== (selectedNav === null || selectedNav === void 0 ? void 0 : selectedNav.nodeId)) {
        selectedItem = getSelectedNavInfo() || {};
      }
    } else {
      selectedItem = navProps.navItems[0] || {};
    }
    var _ref2 = selectedItem || {},
      nodeId = _ref2.nodeId,
      label = _ref2.label;
    nodeId && setSelectedNav({
      nodeId: nodeId,
      label: label
    });
  }, [navProps.defaultSelected]);
  return /*#__PURE__*/React.createElement(StyledMobileNavBarContainer, {
    className: classnames("".concat(ROOT_PREFIX, "-root"), className)
  }, /*#__PURE__*/React.createElement(Accordion, {
    expanded: expanded,
    onChange: handleChange(),
    square: true
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React.createElement("i", {
      className: "icon-expand-more"
    }),
    "aria-controls": "mobile-nav",
    id: "mobile-nav"
  }, selectedNav && /*#__PURE__*/React.createElement(React.Fragment, null, appIcon && /*#__PURE__*/React.createElement("div", {
    className: "".concat(ROOT_PREFIX, "-selected-icon")
  }, /*#__PURE__*/React.createElement("i", {
    className: appIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(ROOT_PREFIX, "-selected-label")
  }, selectedNav.label))), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement(EmbersVerticalNav, _extends({}, navProps, {
    isMobile: true,
    onBeforeSelection: function onBeforeSelection(selection, path, label, childNodes) {
      var _navProps$onBeforeSel;
      var stay = navProps === null || navProps === void 0 || (_navProps$onBeforeSel = navProps.onBeforeSelection) === null || _navProps$onBeforeSel === void 0 ? void 0 : _navProps$onBeforeSel.call(navProps, selection, path, label);
      if (!stay) {
        setSelectedNav({
          nodeId: selection,
          label: label
        });
      }
      if (!(childNodes !== null && childNodes !== void 0 && childNodes.length)) setExpanded(false);
    }
  })))), /*#__PURE__*/React.createElement(Backdrop, {
    open: expanded,
    onClick: function onClick() {
      return setExpanded(false);
    }
  }));
};